export const treechatRadioEnabled = () => true

// Where app.treechat.com/radio lands: the Music stream every station post is
// published to, or home when the server sent no station stream.
export const radioStreamPath = (radioTeamId?: string | null) =>
    radioTeamId ? `/stream/${radioTeamId}` : '/'
